import { useQuery } from '@tanstack/react-query';
import { binder, type BinderBlindingScope } from '@/api/client';
import { binderScopeLabel } from '@/lib/binderScope';

const SCOPE_CLASS: Record<'blinded' | 'unblinded', string> = {
  blinded: 'border-sky-200 bg-sky-50 text-sky-700',
  unblinded: 'border-amber-200 bg-amber-50 text-amber-800',
};

export function BlindingScopeBadge({ scope }: { scope: BinderBlindingScope | null | undefined }) {
  const label = binderScopeLabel(scope || 'open');
  if (!label || !scope || scope === 'open') return null;
  return (
    <span
      className={`inline-flex items-center rounded border px-1.5 py-0.5 text-[10px] font-medium ${SCOPE_CLASS[scope]}`}
      data-testid="blinding-scope-badge"
    >
      {label}
    </span>
  );
}

/**
 * The badge for a DoA page, which only knows its binder by the URL param
 * (BIN-#### or id). Reads the same team-binder list the Delegations page
 * loads, so it is usually already cached.
 */
export function DoaBinderScopeBadge({ binderRef }: { binderRef: string }) {
  const q = useQuery({
    queryKey: ['binder', 'list', 'doa'],
    queryFn: binder.listForDoa,
    staleTime: 60_000,
  });
  const b = q.data?.binders.find((x) => x.reference_number === binderRef || x.binder_id === binderRef);
  return <BlindingScopeBadge scope={b?.blinding_scope} />;
}
